export const selectors = {
    inputs: {
        // Contact
        contactName: '#contact_form_name',
        contactSurname: '#contact_form_surname',
        contactPhone: '#contact_form_phone',
        contactEmail: '#contact_form_email',
        contactMessage: '#contact_form_message',
        contactReCaptcha: '#contact_form_reCaptcha',

        contractMailChangeInput: '#contract-mail_change-email',
        contractMailChangeCancel: '#contract-mail_change-cancel',
        contractMailChangeConfirm: '#contract-mail_change-submit',
        contractMailChangeOpen: '#contract-mail_change-open',
        contractMailChangeBack: '#contract-mail_change-back',
        contractMailChangeTryAgain: '#contract-mail_change-try_again',

        // 0) Homepage
        installments: '#homepage_six_installments_form_installments',

        // 1) AccountInfo
        email: '#registration_form_account_info_data_email',
        phoneNumber: '#registration_form_account_info_data_phoneNumber',
        password: '#registration_form_account_info_data_password_first',
        confirmPassword: '#registration_form_account_info_data_password_second',
        simplePassword: '#registration_simple_password_password_first',
        simpleConfirmPassword: '#registration_simple_password_password_second',
        name: '#registration_form_account_info_data_name',
        surname: '#registration_form_account_info_data_surname',
        dateOfBirth: '#registration_form_account_info_data_dateOfBirth',
        accountInfoReCaptcha: '#registration_form_account_info_data_reCaptcha',

        // 2) Address
        addressAutocomplete: '#registration_form_step_address_addressAutocomplete',
        county: '#registration_form_step_address_county',
        city: '#registration_form_step_address_city',
        street: '#registration_form_step_address_street',
        streetNumber: '#registration_form_step_address_streetNumber',
        houseName: '#registration_form_step_address_houseName',
        flatNumber: '#registration_form_step_address_flatNumber',
        zipCode: '#registration_form_step_address_zipCode',
        peopleSplitRent: '#registration_form_step_address_peopleSplitRent',

        // 3) Employment
        employerName: '#registration_form_step_employment_employerName',
        employerPhoneNumber: '#registration_form_step_employment_employerPhoneNumber',
        monthlyIncome: '#registration_form_step_employment_monthlyIncome',
        totalMonthlyIncome: '#registration_form_step_employment_totalMonthlyIncome',
        dateOfDayPaid: '#registration_form_step_employment_dateOfDayPaid',
        rentMortgage: '#registration_form_step_employment_rentMortgage',
        utilities: '#registration_form_step_employment_utilities',
        numberOfDependents: '#registration_form_step_employment_numberOfDependents',
        loanPayments: '#registration_form_step_employment_loanPayments',
        transport: '#registration_form_step_employment_transport',
        otherHouseholdExpenses: '#registration_form_step_employment_otherHouseholdExpenses',
        food: '#registration_form_step_employment_food',

        // 4) Vulnerabilities
        freeText: 'registration_form_step_vulnerability[freeText]',

        // Card + BankAccount
        bankAccountNumber: '#payment_details_bankAccountNumber',
        bankSortCode: '#payment_details_bankSortCode',
        cardDetails: '#payment_details_cardDetails',

        // Unsubscribe
        unsubscribeEmail: '#email_unsubscribe_email',
        unsubscribePhone: '#sms_unsubscribe_phoneNumber',

        //Contract
        contractPhoneChangeNumber: '#phoneNumber-input',

        // Client - Login / Password reset (reCAPTCHA only, no field validation of their own)
        loginReCaptcha: '#login_form_reCaptcha',
        resetPasswordReCaptcha: '#reset_password_reCaptcha',
        resetPasswordEmail: '#reset_password_email',

        // Client - Password Change
        changePasswordNew: '#change_password_newPassword_first',
        changePasswordConfirm: '#change_password_newPassword_second',
        changePasswordFromResetNew: '#change_password_from_reset_newPassword_first',
        changePasswordFromResetConfirm: '#change_password_from_reset_newPassword_second',
    },
    checkboxes: {
        // 1) AccountInfo
        process: '#registration_form_account_info_data_processDataApprove',

        // 8) Contract
        contractApprovalPrivacy: '#registration_form_sign_contract_approval_privacy',
        contractApprovalMarketing: '#registration_form_sign_contract_approval_marketing',

        // 3) Employment
        confirmDetails: '#registration_form_step_employment_confirmDetails',

        // 4) Vulnerabilities
        financialSupport: '#registration_form_step_vulnerability_financialSupport',
        financialKnowledgeSupport: '#registration_form_step_vulnerability_financialKnowledgeSupport',

        // Card Details
        cardStoreApprove: '#payment_details_cardStoreApprove',

        // 8) Contract
        contractApproval: '#registration_form_sign_contract_approval',
        contractApprovalReview: '#registration_form_sign_contract_approval_review',
        simpleContractApprovalReview: '#registration_simple_form_contract_approval_review',
        simpleContractApprovalPrivacy: '#registration_simple_form_contract_approval_privacy',

        // Reject
        rejectConsent: '#shared_form_reject_consent_consent',
    },
    selects: {
        // 1) AccountInfo
        title: '#registration_form_account_info_data_title',
        maritalStatus: '#registration_form_account_info_data_maritalStatus',

        // 2) Address
        homeOwnerStatus: '#registration_form_step_address_homeOwnerStatus',
        timeAtAddress: '#registration_form_step_address_timeAtAddress',
        typeOfHousing: '#registration_form_step_address_typeOfHousing',

        // 3) Employment
        employmentStatus: '#registration_form_step_employment_employmentStatus',
        workingYears: '#registration_form_step_employment_workingYears',
        salaryPeriodicity: '#registration_form_step_employment_salaryPeriodicity',
        nameOfDayPaid: '#registration_form_step_employment_nameOfDayPaid',

        // 4) Vulnerabilities
        loanReason: '#registration_form_step_vulnerability_loanReason',
        healthConsiderations: '#registration_form_step_vulnerability_healthConsiderations',
        lifeEvents: '#registration_form_step_vulnerability_lifeEvents',
        financialSupport: '#registration_form_step_vulnerability_financialSupport',
        financialResilience: '#registration_form_step_vulnerability_financialResilience',
        capabilityIssues: '#registration_form_step_vulnerability_capabilityIssues',
        financialKnowledgeSupport: '#registration_form_step_vulnerability_financialKnowledgeSupport',
        priorityBillsUpToDate: '#registration_form_step_vulnerability_priorityBillsUpToDate',
    },
    submits: {
        homepageLSI: '#homepage_six_installments_form_save',
        accountInfo: '#registration_form_account_info_data_save',
        personalData: '#registration_form_step_personal_data_save',
        address: '#registration_form_step_address_save',
        employment: '#registration_form_step_employment_save',
        vulnerability: '#registration_form_step_vulnerability_save',
        cardDetails: '#payment_details_save',
        contact: '#contact_form_save',
        contractPhone: '#registration_form_sign_contract_phoneNumberCheck',
        contractEmail: '#registration_form_sign_contract_emailCheck',
        contractPhoneResend: '#phoneNumberCheckResend',
        contract: '#registration_form_sign_contract_save',
        simplePassword: '#registration_simple_password_save',
        unsubscribeEmail: '#email_unsubscribe_save',
        unsubscribePhone: '#sms_unsubscribe_save',
        changePassword: '#change_password_save',
        changePasswordFromReset: '#change_password_from_reset_save',
        rejectConsentContinue: '#shared_form_reject_consent_continue',
        // Login and password reset have no field validation of their own; they are in the ruleset so
        // their reCAPTCHA token is minted by the same external rule as every other form (UKS-1692).
        login: '#login_form_submit',
        resetPassword: '#reset_password_save',
    },
    sliders: {
        instalmentsFocused: 'input:checked',
        tooltipWrapper: '.tooltip-slider-wrap',
        amountWrapper: '.slider-amount',
        calcWrapper: '.slider-calc-wrapper',
        input: 'input.rangeslider',
        handle: '.rangeslider__handle',
        incrementButton: 'div.range-increment',
        decrementButton: 'div.range-decrement',

        // installments
        installmentsCalculator: '#installments_calculator',
        installmentsHomepage: '#installments_homepage',
        installmentsOfferpage: '#installments_offerpage',
        installmentsLoan: '#installments_loan',
    },
    blocks: {
        card: '.card-container .card-inner',
        cardContainer: '.card-container',
        cardSelectContainer: '.card-select-container',
        acquiredCard: '#acquired-form-component',
        acquiredCardUnavailable: '#acquired-card-unavailable',
        sideMenuBurger: '#side_menu_burger',
        sideMenuClose: '#side_menu_close',
        sideMenu: '#side_menu',
        sideMenuBackdrop: '#side_menu_backdrop',
        sideMenuLinks: '#navLink',
        duration: '#calc_results-duration',
        amount: '#calc_results-amount',
        interest: '#calc_results-interest',
        repayable: '#calc_results-repayable',
        APR: '#calc_results-APR',
        phoneVerify: '#phone_verify_form',
        afterSendCode: '.contract-show-after-send-code',
        emailVerify: '#email_verify_form',
        verificationInputs: '.verification-inputs',
        homeOwnerStatusConditional: '#homeOwnerStatusConditional',
    },
    tables: {
        calculator: '#calculator',
        calculatorLoan: '#calculator-loan',
        calculatorExtension: '#calculator-extension',
    },
    toast: {
        toastSuccess: '#live-toast-success',
        toastError: '#live-toast-error',
        toastBody: '.toast-body',
        toastBodyMessage: '.toast-body-msg',
    },
    header: {
        navItem: '.header--nav_item',
        navTrigger: '.header--nav_trigger',
        burger: '#header_burger',
        drawer: '#header_drawer',
        drawerToggle: '[data-drawer-toggle]',
    },
}
